import { useMutation, useQueryClient } from '@tanstack/react-query'
import { demoteAgendaMemberService } from '@/services/agendas'

export const useDemoteAgendaMember = (agendaId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (targetUserId: string) => demoteAgendaMemberService(agendaId, targetUserId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agendas', agendaId, 'members'] })
    },
  })
}
